'use client'
import { Row } from '@shipt/design-system-layouts'
import { HeaderLogo } from '@/features/shared/components/Headers/HeaderLogo'
import { NextLink } from '@/features/shared/elements/Link'
import { useHomeUrl } from '@/features/shared/hooks/useHomeUrl'

export const HeaderLogoLink = () => {
  const homeUrl = useHomeUrl()

  return (
    <NextLink href={homeUrl}>
      <Row>
        <HeaderLogo />
      </Row>
    </NextLink>
  )
}
